import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@fluentui/react-components";

import TableComponent from "../../components/table/TableComponent";

import { AdminService, PaymentTransactionLog } from "../../KulcsUzletSvc";
import { useStylesMainPage } from "../../styles/MainPageStyle";
import { TABLE } from "../../utils/Enums";

export default function TransactionPage() {
  const styles = useStylesMainPage();
  const { transactionid } = useParams();
  const [data, setData] = useState<PaymentTransactionLog[] | null>();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const navigateBack = () => {
    navigate(-1);
  };

  const fetchData = useCallback(async () => {
    if (!transactionid) return;
    setIsLoading(true);
    try {
      const res = await AdminService.getAdminTransactionReport(transactionid);
      setData(res ?? []);
    } catch (e) {
      console.log(e);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, [transactionid]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return (
    <div className={styles.main}>
      <div
        style={{
          textAlign: "center",
          width: "100%",
          fontWeight: "bold",
          fontSize: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Tranzakció azonosító: {transactionid ?? ""}
      </div>
      <div
        style={{
          alignItems: "center",
          justifyContent: "left",
          display: "flex",
          gap: "6px",
          marginBottom: "12px",
        }}
      >
        <Button onClick={navigateBack}>Vissza</Button>
      </div>
      <TableComponent
        type={TABLE.TRANSACTION}
        data={data ?? []}
        isLoading={isLoading}
      />
    </div>
  );
}
